interface State {
  payQueueCounter: number;
  readyToPayCounter: number;
  recentlyPaidCounter: number;
  csvCounter: number
}

const state: State = {
  payQueueCounter: 0,
  readyToPayCounter: 0,
  recentlyPaidCounter: 0,
  csvCounter: 0
};

const mutations = {
  queueToReady (state: State) {
    state.readyToPayCounter = state.readyToPayCounter + 1;
  },
  readyToQueue (state: State) {
    state.payQueueCounter = state.payQueueCounter + 1;
  },
  updatePaidCounter (state: State) {
    state.recentlyPaidCounter = state.recentlyPaidCounter + 1;
  },
  updateCsvCounter (state: State) {
    state.csvCounter = state.csvCounter + 1;
  }
};

const getters = {};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/modules/invoices.ts